import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = ["value"]

import { UseUpload } from "../../../../Pages/SegmentManagement/Uploads/Hooks/UseUpload";
import BatchSegmentFieldConfiguration from "../../../../Modules/SegmentManagement/UploadFileComponents/BatchSegmentFieldConfiguration.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  allSheets,
  currentSheet,
  skipRows,
  firstRowContainsHeaders,
  rows,
  setConfigurationValues,
} = UseUpload();

const handleNumberInput = (e: Event) => {
  const { value } = e.target as HTMLInputElement;
  skipRows.value = parseInt(value);
};

return (_ctx: any,_cache: any) => {
  const _component_o_select = _resolveComponent("o-select")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_switch = _resolveComponent("o-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_unref(allSheets) && _unref(allSheets).length > 1)
      ? (_openBlock(), _createBlock(_component_o_field, {
          key: 0,
          label: "Which sheet is being processed?"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_o_select, {
              modelValue: _unref(currentSheet),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentSheet) ? (currentSheet).value = $event : null)),
              placeholder: "Select a sheet"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allSheets), (sheetName) => {
                  return (_openBlock(), _createElementBlock("option", { value: sheetName }, _toDisplayString(sheetName), 9, _hoisted_2))
                }), 256))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_o_field, { label: "How many rows (if any) are to be skipped at the start?" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_input, {
          onInput: _cache[1] || (_cache[1] = (e) => handleNumberInput(e)),
          "controls-position": "compact",
          type: "number",
          max: _unref(rows),
          value: _unref(skipRows),
          min: "0"
        }, null, 8, ["max", "value"])
      ]),
      _: 1
    }),
    _createVNode(_component_o_field, { label: "Does the top row contain the column headers?" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_switch, {
          modelValue: _unref(firstRowContainsHeaders),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(firstRowContainsHeaders) ? (firstRowContainsHeaders).value = $event : null)),
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref(setConfigurationValues)(['', ''])))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(firstRowContainsHeaders) ? "Yes" : "No"), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(BatchSegmentFieldConfiguration)
  ], 64))
}
}

})